import { useLanguageStore } from "src/store/languageStore";
import ImageButton from "./image-button";

export default function VoiceButton() {
  const voiceOn = useLanguageStore((state) => state.voiceOn);
  const setVoiceOn = useLanguageStore((state) => state.setVoiceOn);

  return (
    <ImageButton
      className="button-glass-blur"
      src={voiceOn ? "/assets/icon_voice_on.png" : "/assets/icon_voice_off.png"}
      onClick={function (): void {
        setVoiceOn(!voiceOn);
      }}
      alt="voice icon"
      size={24}
    />
  );
}
